import { SlotOperation } from '@openedx/frontend-base';

const slots: SlotOperation[] = [];

export default slots;
